<div style="width:680px; min-height:500px">

  <div class="row">
    <div class="col-8">
      <label for="searchFacility">Search for facility</label>
      <input id="searchFacility" type="text" class="search" [(ngModel)]="searchFacility" />
    </div>
    <div class="col-4">
      <button (click)="doSearch()" (keyup.enter)="doSearch()" class="search" [hidden]="!canSearch()">Search&nbsp;<i class="fa fa-search"></i></button>
    </div>
  </div>
  <div [hidden]="searchResults==null || searchResults.length == 0">
  <hr />
    <div class="row">
      <div class="col-12 font-italic">
        Click a facility below to add them
      </div>
    </div>
  <div class="row">
    <div class="col-2 font-weight-bold text-center">
      Code
    </div>
    <div class="col-10 font-weight-bold text-center">
      Name
    </div>
  </div>
    <div class="row selectableDiv" *ngFor="let result of searchResults; index as i" (click)="selectResult(result)">
      <div class="col-2 text-center">
        {{result.FacilityCode}}
      </div>
      <div class="col-10">
        {{result.FacilityName}}
      </div>
    </div>
  </div>
</div>
